// extracted by mini-css-extract-plugin
export var currencyInput = "_ny-1";
export var currencySymbol = "_ny-0";